/**
 * Material-ui transition timeout
 */
export const TRANSITION_DELAY = 500;

/**
 * Debounce delay for changing state values
 */
export const DEFAULT_DEBOUNCE_DELAY = 5; // only a tiny debounce is needed to counterract laggy super-fast changing inputs

/**
 * Time for menu to disappear upon no mouse movement
 */
export const TIME_TO_IDLE = 2000;

/**
 * Default percentage increment for smoothing value input
 */
export const DEFAULT_SMOOTHING_PCNT = 20;
